<script>
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import FormCreator from '../UI/Form/FormCreator.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'

export default {
  components: { FormCreator, FieldCreator, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    params: { type: Object, required: true },
    commentId: { type: Number, required: false },
    method: { type: String, default: 'post' },
  },

  data() {
    return {
      comment: {},
      def: {},
      loadField: false,
      loadForm: false,
      sending: false,
      formData: null,
    }
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    setBuild(bool) {
      this.loadField = bool
    },
    setElement(def, obj) {
      this.def = def
      this.comment = obj
    },
    isSending(bool) {
      this.sending = bool
    },
    showForm() {
      if (this.commentId) {
        this.params['id'] = this.commentId
      }
      this.loadForm = true
    },
    openModal() {
      if (this.commentId) {
        this.$refs['comment' + this.commentId].open()
      } else {
        this.$refs['comment' + this.params.contextId].open()
      }
    },
    closeModal() {
      if (this.commentId) {
        this.$refs['comment' + this.commentId].close(false)
      } else {
        this.$refs['comment' + this.params.contextId].close(false)
      }

      this.loadForm = false
      this.loadField = false

      delete this.params.id
    },
    setDatas(json) {
      this.$emit('comment-sent', { json: json, method: this.method })
      this.closeModal()
    },
  },
}
</script>
<template>
  <ModalDialog
    :id="'comment' + (commentId ? commentId : params.contextId)"
    :ref="'comment' + (commentId ? commentId : params.contextId)"
    class-modal-dialog="modal-xl"
    @icon-close="closeModal"
    v-if="loadForm"
    e2e-modal="comment"
  >
    <template #body>
      <div class="row">
        <FieldCreator
          :form-data="formData"
          v-if="loadField"
          name="comment"
          form-ref="myformcomment"
          domain="comment"
          :label-top="true"
          :editor="true"
        ></FieldCreator>
      </div>
    </template>
    <template #footer>
      <div class="mt-3">
        <FormCreator
          @update-data="updateData"
          ref="myformcomment"
          endpoint="comments"
          :method="method"
          :id="commentId"
          :params="params"
          :in-modal="true"
          class-to-add="btn-lg"
          @modal-build="openModal"
          @form-build="setBuild"
          @element-build="setElement"
          @form-return="setDatas"
          @is-sending="isSending"
        >
          <div v-if="sending" class="text-center">
            <div class="spinner-border" style="width: 1rem; height: 1rem" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-else :e2e-button="commentId ? 'commentUpdate' : 'commentCreate'">
            {{ $t(commentId ? 'button.save' : 'comment.send') }}
          </div>
        </FormCreator>

        <button type="button" class="btn btn-lg btn-info ml-2" @click="closeModal" e2e-button="close">
          {{ $t('main.close') }}
        </button>
      </div>
    </template>
  </ModalDialog>
</template>
